import { trans } from './lang';

export default function showError(form, key = 'recaptcha') {
	form = form.jquery ? form[0] : form;

	form.querySelector('.form-error-alert')?.remove();

	const alert = document.createElement('div');
	alert.className = 'alert alert-danger form-error-alert';
	alert.setAttribute('role', 'alert');
	alert.setAttribute('tabindex', '-1');
	alert.innerHTML  = trans(key);

	form.prepend(alert);

	alert.scrollIntoView({ behavior: 'smooth', block: 'center' });
	alert.focus({ preventScroll: true });
}